// src/components/QRCodeScanner.jsx
import React, { useEffect, useState, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { Button as FcButton } from '../ui';

export default function QRCodeScanner({ onScanSuccess, onClose }) {
  const [error, setError] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const scannerRef = useRef(null);
  const scannerInstanceRef = useRef(null);

  useEffect(() => {
    if (!scannerRef.current) return;

    const scanner = new Html5QrcodeScanner(
      'qr-reader',
      { 
        fps: 10,
        qrbox: { width: 250, height: 250 },
        aspectRatio: 1.0,
        showTorchButtonIfSupported: true,
      },
      /* verbose= */ false
    );

    scannerInstanceRef.current = scanner;

    const onScanSuccessHandler = (decodedText, decodedResult) => {
      
      // Parse the friend URL to extract the friend ID
      try {
        const url = new URL(decodedText);
        const pathParts = url.pathname.split('/');
        const friendIndex = pathParts.indexOf('friend');
        
        if (friendIndex !== -1 && pathParts[friendIndex + 1]) {
          const friendId = pathParts[friendIndex + 1];
          scanner.clear();
          onScanSuccess(friendId);
        } else {
          setError('Invalid QR code. Please scan a valid Friend QR code.');
        }
      } catch (err) {
        // If it's not a URL, assume it's a direct friend ID
        if (decodedText && decodedText.length === 8) {
          scanner.clear();
          onScanSuccess(decodedText);
        } else {
          setError('Invalid QR code format.');
        }
      }
    };

    const onScanFailure = (error) => {
    };

    scanner.render(onScanSuccessHandler, onScanFailure);
    setIsScanning(true);

    return () => {
      if (scannerInstanceRef.current) {
        scannerInstanceRef.current.clear().catch(err => {
        });
      }
    };
  }, [onScanSuccess]);

  const handleManualInput = () => {
    if (scannerInstanceRef.current) {
      scannerInstanceRef.current.clear().catch(err => {
      });
    }
    onClose();
  };

  return (
    <div className="flex flex-col items-center space-y-4 p-6">
      <h3 className="text-xl font-bold text-brand-text">Scan Friend QR Code</h3>
      <p className="text-sm text-content-secondary text-center">
        Position the QR code within the frame to scan
      </p>

      {error && (
        <div className="bg-red-100 border border-red-400 text-ui-error px-4 py-3 rounded relative w-full">
          <span className="block sm:inline">{error}</span>
          <FcButton variant="tertiary" type="submit"
            onClick={() => setError(null)}
            className="absolute top-0 bottom-0 right-0"
          >
            <span className="text-xl">&times;</span>
          </FcButton>
        </div>
      )}

      <div 
        id="qr-reader" 
        ref={scannerRef}
        className="w-full max-w-md"
      />

      <div className="flex gap-2 mt-4">
        <FcButton variant="tertiary" type="submit"
          onClick={handleManualInput}
          className=""
        >
          Enter Manually Instead
        </FcButton>
      </div>

      <div className="text-sm text-content-secondary text-center mt-4">
        <p>Camera access is required to scan QR codes.</p>
        <p>Make sure you've granted permission in your browser.</p>
      </div>
    </div>
  );
}
